import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '项目名称',
      placeholder: '请输入项目名称',
      rules: { required: true, message: '项目名称是必传的', trigger: 'blur' }
    },
    {
      field: 'ip',
      type: 'input',
      label: '服务器IP',
      placeholder: '请输入服务器IP',
      rules: { required: true, message: '服务器IP是必传的', trigger: 'blur' }
    },
    {
      field: 'certificate',
      type: 'input',
      label: '证书名称',
      placeholder: '请输入证书名称',
      rules: { required: true, message: '证书名称是必传的', trigger: 'blur' }
    },
    {
      field: 'endTime',
      type: 'datepicker',
      label: '到期时间',
      otherOptions: {
        placeholder: '选择到期时间',
        'value-format': 'YYYY-MM-DD'
      }
    },
    {
      field: 'aliAccount',
      type: 'input',
      label: '阿里云账号',
      placeholder: '请输入阿里云账号',
      rules: { required: true, message: '阿里云账号是必传的', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
